import SearchIcon from '@mui/icons-material/Search';
import { alpha, styled, InputBase, Box, IconButton, Stack, Badge } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import { useCallback, useState } from 'react';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: '8px',
  border: '1px solid #666666',
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%'
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

const RecordSearch = ({
    sx,
    filterCallback,
    needFilterReset=false,
    searchAPICall,
    setSearchKey
}) => {
    const [searchTimer, setSearchTimer] = useState(null);

    const searchOnChange = useCallback((event) => {
        const value = event.target.value;

        setSearchKey(value);

        if (searchTimer) {
            clearTimeout(searchTimer);
        }

        if (!value) {
            setSearchKey('');
        }

        const newSearchTimer = setTimeout(() => {
            console.log(value);

            // Call API here
            searchAPICall(value);
        }, 1000);

        setSearchTimer(newSearchTimer);
    }, [searchTimer]);

    return (
        <>
            <Stack
                direction='row'
                spacing={2}
                sx={{
                    width: '100%',
                    ...sx
                }}
            >
                <Search>
                    <SearchIconWrapper>
                        <SearchIcon />
                    </SearchIconWrapper>
                                
                    <StyledInputBase
                        placeholder="Search…"
                        inputProps={{ 'aria-label': 'search' }}
                        onChange={searchOnChange}
                    />
                </Search>

                <IconButton 
                    aria-label="delete"
                    sx={{
                        display: filterCallback ? 'flex' : 'none'
                    }}
                    onClick={filterCallback}
                >
                    <Badge color="primary" variant="dot" invisible={!needFilterReset}>
                        <TuneIcon />
                    </Badge>
                </IconButton>
            </Stack>
        </>
    );
}

export default RecordSearch;